import { palette } from "lib/miolo";
import FundamentalsChartContext from "components/fundamentals/FundamentalsChartContext";
import { Fundaments } from "components/fundamentals/Fundaments";
import FundamentToggle from "components/fundamentals/FundamentToggle";
import type { ReactElement } from "react";

export default function InsurerFundamentalsToggles(): ReactElement {
  return (
    <FundamentalsChartContext.Consumer>
      {({ fundaments, selectableFundaments, toggle, selectOnly }) => (
        <>
          <FundamentToggle
            labelText="Equity"
            labelTextColor={palette.kumera}
            backgroundColor={palette.linen}
            isActive={fundaments.includes(Fundaments.TOTAL_EQUITY)}
            onClick={() => toggle(Fundaments.TOTAL_EQUITY)}
            onDoubleClick={() => selectOnly(Fundaments.TOTAL_EQUITY)}
          />

          <FundamentToggle
            labelText="Revenue"
            labelTextColor={palette.fruitSalad}
            backgroundColor="#EEFBEF"
            isActive={fundaments.includes(Fundaments.REVENUE)}
            onClick={() => toggle(Fundaments.REVENUE)}
            onDoubleClick={() => selectOnly(Fundaments.REVENUE)}
          />

          {selectableFundaments.includes(Fundaments.EBITDA) && (
            <FundamentToggle
              labelText="EBITDA"
              labelTextColor={palette.seaGreen}
              backgroundColor="#EEFBEF"
              isActive={fundaments.includes(Fundaments.EBITDA)}
              onClick={() => toggle(Fundaments.EBITDA)}
              onDoubleClick={() => selectOnly(Fundaments.EBITDA)}
            />
          )}

          <FundamentToggle
            labelText="Net Inc."
            labelTextColor={palette.oceanGreen}
            backgroundColor="#EEFBEF"
            isActive={fundaments.includes(Fundaments.NET_INCOME)}
            onClick={() => toggle(Fundaments.NET_INCOME)}
            onDoubleClick={() => selectOnly(Fundaments.NET_INCOME)}
          />

          <FundamentToggle
            labelText="Net Mar."
            labelTextColor="#507712"
            backgroundColor="#EEFBEF"
            isActive={fundaments.includes(Fundaments.NET_MARGIN)}
            onClick={() => toggle(Fundaments.NET_MARGIN)}
            onDoubleClick={() => selectOnly(Fundaments.NET_MARGIN)}
          />

          <FundamentToggle
            labelText="ROE"
            labelTextColor={palette.stromboli}
            backgroundColor="#EEFBEF"
            isActive={fundaments.includes(Fundaments.RETURN_ON_EQUITY)}
            onClick={() => toggle(Fundaments.RETURN_ON_EQUITY)}
            onDoubleClick={() => selectOnly(Fundaments.RETURN_ON_EQUITY)}
          />

          <FundamentToggle
            labelText="Cash"
            labelTextColor={palette.dixie}
            backgroundColor="#FCF4F4"
            isActive={fundaments.includes(Fundaments.CASH)}
            onClick={() => toggle(Fundaments.CASH)}
            onDoubleClick={() => selectOnly(Fundaments.CASH)}
          />

          {selectableFundaments.includes(Fundaments.DEBT) && (
            <FundamentToggle
              labelText="Debt"
              labelTextColor={palette.burntUmber}
              backgroundColor="#FCF4F4"
              isActive={fundaments.includes(Fundaments.DEBT)}
              onClick={() => toggle(Fundaments.DEBT)}
              onDoubleClick={() => selectOnly(Fundaments.DEBT)}
            />
          )}

          {selectableFundaments.includes(Fundaments.NET_DEBT) && (
            <FundamentToggle
              labelText="Net Debt"
              labelTextColor={palette.mojo}
              backgroundColor="#FCF4F4"
              isActive={fundaments.includes(Fundaments.NET_DEBT)}
              onClick={() => toggle(Fundaments.NET_DEBT)}
              onDoubleClick={() => selectOnly(Fundaments.NET_DEBT)}
            />
          )}

          <FundamentToggle
            labelText="OCF"
            labelTextColor={palette.tundora}
            backgroundColor={palette.lilyWhite}
            isActive={fundaments.includes(Fundaments.CASH_FLOW_FROM_OPERATIONS)}
            onClick={() => toggle(Fundaments.CASH_FLOW_FROM_OPERATIONS)}
            onDoubleClick={() => selectOnly(Fundaments.CASH_FLOW_FROM_OPERATIONS)}
          />

          <FundamentToggle
            labelText="Free"
            labelTextColor={palette.scienceBlue}
            backgroundColor={palette.lilyWhite}
            isActive={fundaments.includes(Fundaments.FREE_CASH_FLOW)}
            onClick={() => toggle(Fundaments.FREE_CASH_FLOW)}
            onDoubleClick={() => selectOnly(Fundaments.FREE_CASH_FLOW)}
          />

          <FundamentToggle
            labelText="Div."
            labelTextColor={palette.luxorGold}
            backgroundColor="#FCF9F0"
            isActive={fundaments.includes(Fundaments.CASH_FLOW_FOR_DIVIDENDS)}
            onClick={() => toggle(Fundaments.CASH_FLOW_FOR_DIVIDENDS)}
            onDoubleClick={() => selectOnly(Fundaments.CASH_FLOW_FOR_DIVIDENDS)}
          />

          <FundamentToggle
            labelText="Payout"
            labelTextColor="#CB6E17"
            backgroundColor="#FCF9F0"
            isActive={fundaments.includes(Fundaments.PAYOUT)}
            onClick={() => toggle(Fundaments.PAYOUT)}
            onDoubleClick={() => selectOnly(Fundaments.PAYOUT)}
          />

          {selectableFundaments.includes(Fundaments.DIVIDEND_YIELD) && (
            <FundamentToggle
              labelText="DY"
              labelTextColor="#C99A2E"
              backgroundColor="#FCF9F0"
              isActive={fundaments.includes(Fundaments.DIVIDEND_YIELD)}
              onClick={() => toggle(Fundaments.DIVIDEND_YIELD)}
              onDoubleClick={() => selectOnly(Fundaments.DIVIDEND_YIELD)}
            />
          )}

          {selectableFundaments.includes(Fundaments.EARNINGS_PER_SHARE) && (
            <FundamentToggle
              labelText="EPS"
              labelTextColor={palette.mineShaft}
              backgroundColor={palette.catskillWhite}
              isActive={fundaments.includes(Fundaments.EARNINGS_PER_SHARE)}
              onClick={() => toggle(Fundaments.EARNINGS_PER_SHARE)}
              onDoubleClick={() => selectOnly(Fundaments.EARNINGS_PER_SHARE)}
            />
          )}

          {selectableFundaments.includes(Fundaments.REPURCHASE_OF_CAPITAL_STOCK) && (
            <FundamentToggle
              labelText="Buyback"
              labelTextColor={palette.luxorGold}
              backgroundColor="#FCF9F0"
              isActive={fundaments.includes(Fundaments.REPURCHASE_OF_CAPITAL_STOCK)}
              onClick={() => toggle(Fundaments.REPURCHASE_OF_CAPITAL_STOCK)}
              onDoubleClick={() => selectOnly(Fundaments.REPURCHASE_OF_CAPITAL_STOCK)}
            />
          )}
        </>
      )}
    </FundamentalsChartContext.Consumer>
  );
}
